var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import FormGroupHorizontal from '../FormGroupHorizontal';
var TogglerHorizontal = /** @class */ (function (_super) {
    __extends(TogglerHorizontal, _super);
    function TogglerHorizontal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TogglerHorizontal.prototype.render = function () {
        var _a = this.props, name = _a.name, label = _a.label, checked = _a.checked, onChange = _a.onChange, inputCols = _a.inputCols, labelCols = _a.labelCols, descriptionChecked = _a.descriptionChecked, descriptionUnchecked = _a.descriptionUnchecked, className = _a.className, id = _a.id;
        var newId = id ? id : name + '_' + Math.random();
        return (React.createElement(FormGroupHorizontal, { leftContent: React.createElement("label", { htmlFor: newId }, label), rightContent: React.createElement("div", { className: 'd-flex align-items-center' },
                React.createElement("input", { className: 'ml-0 mr-x2', id: newId, type: 'checkbox', name: name, checked: checked, onChange: function (evt) {
                        onChange(evt.target.checked);
                    } }),
                checked ? descriptionChecked : descriptionUnchecked), leftCols: labelCols, rightCols: inputCols, className: className }));
    };
    return TogglerHorizontal;
}(Component));
export default TogglerHorizontal;
//# sourceMappingURL=TogglerHorizontal.js.map